<template>
	<div id="home">
		<div class="imgWrapper">
			<div class="mobileLook">
				<div class="mobileLogo"
						:style="{
							'background-image': 'url(' + logoMobile.url + ')'
						}">
					
				</div>

				<div class="mobileHeader">
					<h1 class="mobName">Emily Qualmann</h1>
					
					<div class="nameBullets">			
						<h1>SINGER.</h1>
						<h1>ACTRESS.</h1>
						<h1>COMEDIENNE.</h1>
					</div>
				</div>				
			</div>

			<div class="headshotImg" 
					:style="{
                        'background-image': 'url(' + profilePic.url + ')'
                    }">
			</div>

			<div class="nameTag">
				<div class="nameSign"
						:style="{
							'background-image': 'url(' + signature.url + ')'
						}">
				</div>

				<div class="nameBullets">			
					<h1>SINGER.</h1>
					<h1>ACTRESS.</h1>
					<h1>COMEDIENNE.</h1>
				</div>
			</div>
		</div>

		<div class="homeWrapper">
			<div class="bullets" 
					:style="{
						'background-image': 'url(' + signature.url + ')'
					}">			
				<h1>SINGER.</h1>
				<h1>ACTRESS.</h1>
				<h1>COMEDIENNE.</h1>
			</div>

			<div class="socialIcons">
                <a target="_blank" rel="noopener" href="mailto:emilyqualmann@gmail.com">
                    <i class="fa fa-envelope fa-2x" aria-hidden="true"></i>
                </a>

                <a target="_blank" rel="noopener" href="https://www.instagram.com/emilyqualmann/">
                    <i class="fa fa-instagram fa-2x" aria-hidden="true"></i>
                </a>				

                <a target="_blank" rel="noopener" href="https://soundcloud.com/user-807035398">
                    <i class="fa fa-soundcloud fa-2x" aria-hidden="true"></i>
                </a>				

                <a target="_blank" rel="noopener" href="https://www.youtube.com/channel/UC1mbMp1chMSffdOMYNgrsCg">
                    <i class="fa fa-youtube-play fa-2x" aria-hidden="true"></i>
                </a>				
			</div>
		</div>

	</div>
</template>

<script>
export default {
  name: 'Home',
  props:[
  	'profilePic',
  	'signature',
  	'logoMobile'
  ]
}
</script>

<style scoped lang="scss">
	@import "~@/assets/scss/_variables.scss";

	@import "~@/assets/scss/_mixins.scss";

	#home{
		min-width: 100%;
		height: 90vh;
		background: $headshotBack;
		border: 20px solid $nearWhite;
		display: grid;
		grid-template-columns: 50% 50%;

		.imgWrapper{
			height: 100%;
			width: 100%;

			.mobileLook{
				display: none;

				.mobileLogo, mobileHeader{
					display: none; 
				}
			}

			.nameTag{
				display: none;
			}

			.headshotImg{
				float: left;
				width: 100%;
				height: 100%;

				// background-position:10% 20%;
				background-position:top;
				background-repeat:no-repeat;
				background-size:cover;
			}
		}

		.homeWrapper{
			background: $beigePink;
			border-left: 20px solid $nearWhite;
			display: grid;
			grid-template-rows: 85% 15%;

			.bullets{
				display: grid;
				align-items: center;
				color: $nearWhite;

				background-position:center;
				background-repeat:no-repeat;
				background-size: contain;

				h1{
					font-family: 'Montserrat', sans-serif;
					font-weight: 900;
					font-size: 5rem;
					padding: 0 10px;
					text-shadow: -10px 0px 20px #6f848f6e;
				}
			}

			.socialIcons{
				width: 100%;
				display: grid;
				grid-template-columns: 25% 25% 25% 25%;
				background: $nearWhite;

				a {
					height: 4em;
    				width: 4em;
    				margin: auto;
    				transition: all .2s ease-in-out;
					border-radius: 50%;
					color: $darkPurple;
					text-align: center;

					i{
						transform: translateY(50%);
						margin: auto;
						width: 100%;
					}

					&:hover{
						background: $beigeMint;
						color: white;
						border-color: $beigeMint;
					}
				}
			}
		}
	}

	@media screen and (max-width: $largeLaptopWidth){
		#home{}
	}

	@media screen and (max-width: $regularLaptopWidth){
		#home{
			.imgWrapper{
				.nameTag{
					display:none;
				}
			}

			.homeWrapper{
				.bullets{
					h1{
						font-size: 3rem;
					}
				}
			}
		}
	}

    @media screen and (max-width: $tabletWidth){
		#home{
			grid-template-columns: 100%;
			grid-template-rows: 85% 15%;
			background: $nearWhite;

			.imgWrapper{
				.headshotImg{
					width: 50%;
					background-position: center;
					background-size: contain;
				}

				.nameTag{
					display: grid;
					grid-template-rows: 50% 50%;
					font-family: 'Montserrat', sans-serif;
					font-weight: 900;
					font-size: 3rem;
					height: 100%;
					max-width: 100%;
					overflow: hidden;

					.nameSign{
						background-repeat: no-repeat;
						background-position: center;
						background-size: contain;
						text-align: center;
					}

					.nameBullets{
						font-size: 2rem;
						display: grid;
						color: black;
						text-align: right;

						h1{
							transform: translateY(calc(50%));
						}
					}
				}
			}

			.homeWrapper{
				border: none;
				background: transparent;
				grid-template-rows: 100%;

				.bullets{
					display: none;
				}

				.socialIcons{
					a{
						padding: 0;
					}
				}
			}

		}
    }

    @media screen and (max-width: $largeMobile){
    	#home{
    		height: 100vh;
			grid-template-rows: 80% 10%;
    		
    		.imgWrapper{
    			display: grid;
    			grid-template-rows: 20% 80%;

    			.mobileLook{
    				display: grid;
    				grid-template-columns: 30% 70%;

    				.mobileLogo{
    					display: inherit;
						height: 100%;
						background-repeat: no-repeat;	
						background-size: contain;				
						background-position: center;    					
    				}

					.mobileHeader {
						font-size: 2em;
						font-family: 'Montserrat', sans-serif;
						margin: auto;
						// transform: translateY(calc(50% - 1rem));
						display: grid;
						height: 70%;
						text-align: center;

						.mobName{
							font-weight: bold;
							margin: auto 0;
							text-align: center;
						}

						.nameBullets{
							display: grid;
							grid-template-columns: 1fr 1fr 1fr;
							margin: auto;

							h1{
								font-size: .5rem;
							}
						}
					}

    			}

    			.headshotImg{
    				width: 100%;
				}

    			.nameTag{
    				display: none;
    			}
    		}

			.homeWrapper{
				border: none;
				background: transparent;
				grid-template-rows: 100%;

				.bullets{
					display: none;
				}

				.socialIcons{
					a{
						padding: 0;
						i{
							transform: translateY(50%);
						}
					}
				}
			}    		
    	}
    }


    @media screen and (max-width: $smallMobile){
        #about{
        }
    }	
</style>